import { UIHeading4, Body2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ChatCompanionTitle.css';

interface IChatCompanionTitleProps {
  primaryText: string;
  secondaryText?: string | null;
  handleClickName?: VoidFunction;
  dataTestId?: string;
}

export const ChatCompanionTitle: React.FC<IChatCompanionTitleProps> = ({
  primaryText,
  secondaryText,
  handleClickName,
  dataTestId,
}) => {
  return (
    <div className={styles['title']} data-testid={dataTestId} onClick={handleClickName}>
      <UIHeading4 ellipsis>{primaryText}</UIHeading4>

      {secondaryText && <Body2 color="text-secondary-default">{secondaryText}</Body2>}
    </div>
  );
};
